"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Recognition = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var Recognition = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Recognition, _super);
    function Recognition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '卡号识别银行接口';
        _this.code = '101061';
        _this.desc = '卡号识别银行接口';
        _this.requestParams = new bankCard_1.RecognitionRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Recognition;
}(service_1.BaseService));
exports.Recognition = Recognition;
//# sourceMappingURL=recognition.js.map